import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Home, ArrowLeft } from "lucide-react";
import "./NotFound.css";

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="not-found-container">
      {/* Elementos flotantes decorativos */}
      <div className="floating-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
        <div className="shape shape-4"></div>
        <div className="shape shape-5"></div>
      </div>

      <div className="not-found-content">
        <div className="glitch-wrapper">
          <h1 className="not-found-title glitch" data-text="404">
            404
          </h1>
        </div>

        <div className="subtitle-wrapper">
          <h2 className="not-found-subtitle">{t("notFound.title")}</h2>
          <div className="subtitle-underline"></div>
        </div>

        <p className="not-found-description">{t("notFound.description")}</p>

        <div className="button-group">
          <Link to="/" className="not-found-button primary">
            <Home size={20} />
            <span>{t("notFound.button")}</span>
          </Link>
          <button
            onClick={() => window.history.back()}
            className="not-found-button secondary"
          >
            <ArrowLeft size={20} />
            <span>{t("notFound.back")}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
